<h3 class="step-title">Velg startdato</h3>

<app-ice-select-box label="Så fort som mulig" [control]="isEarliestDateControl" [value]="true">
  <div header>
    {{ earliestDateLabel }}
  </div>
</app-ice-select-box>

<app-ice-select-box label="Velg eget tidspunkt" [control]="isEarliestDateControl" [hideOverflow]="false" [value]="false">
  <div header>{{ activationTimeBoxLabel }}</div>
  <div>
    <app-ice-date-picker
      buttonTestId="mbb-activation-date-button"
      errorText="Datoen du har valgt er ikke tillatt"
      formControlName="activationDate"
      label="Dato"
      ngDefaultControl
      placeholder="dd.mm.yyyy"
      textTestId="mbb-activation-date-input"
      [maxDate]="maxDate"
      [minDate]="minDate"
    />
  </div>
</app-ice-select-box>
